import React from "react";

const getAvatarSrc = (user) => {
  if (!user) return "/Male-Saudi-Arabian.png";
  if (user.photo) return user.photo;
  const gender = user.gender?.toLowerCase();
  if (gender === "female" || gender === "f") return "/Female-avatar.png";
  return "/Male-Saudi-Arabian.png";
};

const UserAvatar = ({ user, size = "md", isSupport = false }) => {
  const sizeClass =
    size === "sm"
      ? "w-7 h-7 md:w-9 md:h-9 text-xs"
      : "w-9 h-9 md:w-11 md:h-11 text-sm";
  const src = isSupport
    ? "/support/ghorfatech-support.png"
    : getAvatarSrc(user);

  return (
    <img
      src={src}
      alt="avatar"
      className={`${sizeClass} rounded-full object-cover border border-gray-200 dark:border-gray-600 flex-shrink-0`}
    />
  );
};

export default UserAvatar;
